import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import AuthService from 'cio/services/auth';

export default class LogoutRoute extends Route {
  @service auth!: AuthService;

  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    return this.auth.logout();
  }
}
